module.exports = __webpack_public_path__ + "static/media/imagen.0ff48e4c.jpg";